import { useEffect } from "react";

export default function Resizer() {
  useEffect(() => {
    let isResizing = false;

    const resizer = document.getElementById("resizer");
    const sidebar = document.getElementById("sidebar");

    const onMouseMove = (e) => {
      if (!isResizing || window.innerWidth <= 700) return;

      if (e.clientX > 200 && e.clientX < 600) {
        sidebar.style.width = e.clientX + "px";
      }
    };

    const onMouseUp = () => {
      isResizing = false;
      document.body.style.cursor = "default";
    };

    const onMouseDown = () => {
      isResizing = true;
      document.body.style.cursor = "col-resize";
    };

    resizer?.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);

    return () => {
      resizer?.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, []);

  return <div id="resizer" />;
}